import { createContext } from "react";

const UserContext=createContext({
    loggedIUser:"Sankalita"
});

export default UserContext;